let VCA = VCA || {};

VCA.ResetPassword = (function ($) {

    let ui = {};
    let haveOneNumValid = false;
    let haveOneUppercaseValid = false;
    let haveOneLowercaseValid = false;
    let haveOneSpecialCharValid = false;
    let have8MinCharValid = false;
    let generalPwFinalValue = '';
    let confirmPwFinalValue = '';
    let passwordValidAndMatched = false;

    function cacheUI() {
        ui.$ResetPasswordForm = $('#ResetPasswordForm');
        ui.$ResetPasswordBtn = $('#ResetPasswordSubmitBtn');
        ui.$ResetPasswordInput = $('.reset-password-input');
        ui.$UnsuccessfulErrMsg = $('.acct-reset-password__be-error-msg');
        ui.$SuccessMsg = $('.acct-reset-password__be-success-msg');
        ui.$PasswordEyeIcon = $('.password-eye-icon');
    }
    
    function bindEvents() {
        ui.$PasswordEyeIcon.on('click', togglePassword);
        ui.$ResetPasswordInput.on('focus', showTooltipModal);
        ui.$ResetPasswordInput.on('blur', hideTooltipModal);
        ui.$ResetPasswordInput.on('keyup paste', validatePassword);
        ui.$ResetPasswordForm.on('submit', submitForm);
    }

    function checkIfErrorMsgIsPresent() {
        let errorMsg = ui.$UnsuccessfulErrMsg.html().trim();

        if (errorMsg.length == 0) {
            ui.$UnsuccessfulErrMsg.hide();
        } else {
            ui.$UnsuccessfulErrMsg.show();
        }
    }

    function checkIfSuccessMsgIsPresent() {

        let successMsg = ui.$SuccessMsg.html().trim();

        if (successMsg.length == 0) {
            ui.$SuccessMsg.hide();
        } else {
            ui.$SuccessMsg.show();
            window.VCA.AccountDatalayer.dataLayerResetPasswordSuccess();
        }
    }

    function togglePassword() {
        // toggle the type attribute
        let passwordInput = $(this).closest('.form-label-group').find('.reset-password-input');
        const type = $(passwordInput).attr('type') === 'password' ? 'text' : 'password';
        $(passwordInput).attr('type', type);
        // toggle the eye slash icon
        $(this).toggleClass('fa-eye-slash');
    }

    function showTooltipModal(e) {
        let pwInputEl = $(e.currentTarget);
        pwInputEl.closest('.form-label-group').find('.password-tooltip').show(); 
    }

    function hideTooltipModal(e) {
        let pwInputEl = $(e.currentTarget);
        pwInputEl.closest('.form-label-group').find('.password-tooltip').hide(); 
    }

    function validatePassword() {
        let passwordInput = this;
        let inputType = $(passwordInput).data('type');

        ui.$ResetPasswordInput.removeClass('error');
        ui.$UnsuccessfulErrMsg.hide();
        ui.$SuccessMsg.hide();

        if (inputType == 'general-password'){
            let generalPwValue = $(passwordInput).val();
            $(passwordInput).attr('value', generalPwValue);
            generalPwFinalValue = generalPwValue;

            // Have one number
            const oneNumRegex = /\d/;
            const hasOneNum = generalPwValue.match(oneNumRegex);
            let hasOneNumCircle = $('#PwOneNumber').siblings('.fill-circle');

            if (hasOneNum) {
                $(hasOneNumCircle).addClass('active');
                haveOneNumValid = true;
            } else {
                $(hasOneNumCircle).removeClass('active'); 
                haveOneNumValid = false;
            }

            //Have one uppercase character
            const oneUppercaseChar = /[A-Z]/;
            const hasOneUppercaseChar = generalPwValue.match(oneUppercaseChar);
            let hasOneUppercaseCircle = $('#PwOneUppercaseChar').siblings('.fill-circle');

            if (hasOneUppercaseChar) {
                $(hasOneUppercaseCircle).addClass('active');
                haveOneUppercaseValid = true;
            } else {
                $(hasOneUppercaseCircle).removeClass('active');
                haveOneUppercaseValid = false;
            }

            //Have one lowercase character
            const oneLowercaseChar = /[a-z]/;
            const hasOneLowercaseChar = generalPwValue.match(oneLowercaseChar);
            let hasOneLowercaseCircle = $('#PwOneLowercaseChar').siblings('.fill-circle');

            if (hasOneLowercaseChar) {
                $(hasOneLowercaseCircle).addClass('active');
                haveOneLowercaseValid = true;
            } else {
                $(hasOneLowercaseCircle).removeClass('active');
                haveOneLowercaseValid = false;
            }

            //Have one special chracter
            const oneSpecialChar = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
            const hasOneSpecialChar = generalPwValue.match(oneSpecialChar);
            let hasOneSpecialCircle = $('#PwOneSpecialChar').siblings('.fill-circle');

            if (hasOneSpecialChar) {
                $(hasOneSpecialCircle).addClass('active');
                haveOneSpecialCharValid = true;
            } else {
                $(hasOneSpecialCircle).removeClass('active');
                haveOneSpecialCharValid = false;
            }

            //Have 8 characters min
            const min8Char = /^(?=.*\d).{8,}$/;
            const hasMin8Char = generalPwValue.match(min8Char);
            let hasMin8CharCircle = $('#PwMin8Char').siblings('.fill-circle');

            if (hasMin8Char) {
                $(hasMin8CharCircle).addClass('active');
                have8MinCharValid = true;
            } else {
                $(hasMin8CharCircle).removeClass('active');
                have8MinCharValid = false;
            }

            //Use case to see if passwords match
            let pwMatchCircle = $('#PasswordsMatch').siblings('.fill-circle');
            if (confirmPwFinalValue.trim() !== '' && generalPwFinalValue.trim() !== '' && confirmPwFinalValue == generalPwFinalValue) {
                $(pwMatchCircle).addClass('active');

                if (haveOneNumValid && haveOneUppercaseValid && haveOneLowercaseValid && haveOneSpecialCharValid && have8MinCharValid) {
                    ui.$Password = generalPwValue;
                    passwordValidAndMatched = true;
                }
            } else {
                $(pwMatchCircle).removeClass('active');
                passwordValidAndMatched = false;
            }
        } 

        if (inputType == 'confirm-password'){

            let confirmPwValue = $(passwordInput).val();
            let passwordsMatchCircle = $('#PasswordsMatch').siblings('.fill-circle');
            $(passwordInput).attr('value', confirmPwValue);
            confirmPwFinalValue = confirmPwValue;

            if (confirmPwFinalValue.trim() !== '' && generalPwFinalValue.trim() !== '' && confirmPwFinalValue == generalPwFinalValue) {
                $(passwordsMatchCircle).addClass('active');

                if (haveOneNumValid && haveOneUppercaseValid && haveOneLowercaseValid && haveOneSpecialCharValid && have8MinCharValid) {
                    ui.$Password = confirmPwValue;
                    passwordValidAndMatched = true;
                }
            } else {
                $(passwordsMatchCircle).removeClass('active');
                passwordValidAndMatched = false;
            }
        }
        
    }

    function submitForm(e) {
        validatePassword();

        if (passwordValidAndMatched) {
            return true;
        } else {
            e.preventDefault();
            ui.$ResetPasswordInput.addClass('error');
            return false;
        }
    }

    function init() {
        if ($('.acct-reset-password').length <= 0) {
            return;
        }

        cacheUI();
        bindEvents();
        checkIfErrorMsgIsPresent();
        checkIfSuccessMsgIsPresent();
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    VCA.ResetPassword.init();
});